module.exports = "<div class=\"ui-message ui-messages-error ui-corner-all\" *ngIf=\"(kindForms == '1')\">\n    <i class=\"fa {{icon}}\"></i>\n    <ng-content></ng-content>\n</div>\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/custom-component/formGroupError.component.html
// module id = ./src/app/theme/layouts/custom-component/formGroupError.component.html
// module chunks = main